import React from "react";
import { IIcons } from "./icons";

const RightArrowFilledIcon = ({ fillColor }: IIcons.IconProps) => (
  <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 9.5L0.249999 18.5933L0.25 0.406733L16 9.5Z" fill="#0F5BF1" className={fillColor} />
  </svg>
);
export default RightArrowFilledIcon;
